// Math utilty functions

const mathMin = Math.min;
const mathMax = Math.max;
const mathCeil = Math.ceil;
const mathPow = Math.pow;
const mathRound = Math.round;

export { mathCeil, mathMax, mathMin, mathPow, mathRound };
